import * as textConstants from '../text/constants';

export const { SIZES, APPEARANCES, TYPES } = textConstants;

export const TARGETS = {
  blank: '_blank',
  self: '_self',
};
